import { render, staticRenderFns } from "./TaskDetails.vue?vue&type=template&id=45b73226&scoped=true&"
import script from "./TaskDetails.vue?vue&type=script&lang=ts&"
export * from "./TaskDetails.vue?vue&type=script&lang=ts&"
import style0 from "./TaskDetails.vue?vue&type=style&index=0&id=45b73226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b73226",
  null
  
)

export default component.exports